// vuex的总入口文件
import Vue from "vue";
import Vuex from "vuex";
import user from "@/store/modules/user"; // 刚刚写的模块
import global from "@/store/modules/global";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    global
  }
});
export default store;
